import type { DashboardConfig } from '../config';
import { brazilConfig } from './brazil';
import { spainConfig } from './spain';
import { franceConfig } from './france';
import { france50Config } from './france50';
import { cocaColaQuickConfig } from './cocaColaQuick';
import { monopolyConfig } from './monopoly';
import { ahConfig } from './ah';
import { ahPrijsfavorietenConfig } from './ahPrijsfavorieten';
import { systemeUSurveyConfig } from './systemeUSurvey';
import { morrisonsDisneyConfig } from './morrisonsDisney';
import { systemeUMinionsConfig } from './systemeUMinions';

/**
 * Registry of all dashboard configs. App.tsx generates routes from this.
 * To add a new client: create a new file in this folder, import it here.
 */
export const DASHBOARD_CONFIGS: ReadonlyArray<DashboardConfig> = [
  brazilConfig,
  spainConfig,
  franceConfig,
  france50Config,
  cocaColaQuickConfig,
  monopolyConfig,
  systemeUSurveyConfig,
  systemeUMinionsConfig,
  morrisonsDisneyConfig,
  ahPrijsfavorietenConfig,
  ahConfig,
];
